/**
 * React hook for community message like state.
 *
 * Reactive read from SecureStorage — mirrors useCommentLike. Updates
 * automatically when any component toggles the like via
 * LikeCommunityMessageUseCase (which writes to the same storage key).
 *
 * Web port of Flutter's Hive box read + watch
 * (lib/presentation/custom_widgets/communit_message_widget.dart:78-118): the
 * initial value comes from the login sync
 * (syncSecureStorageUseCase.syncCommunityMessageLikes) and re-renders fire from
 * the optimistic write/revert in LikeCommunityMessageUseCase via
 * useListenToSecureStorageUpdates.
 */

import { useListenToSecureStorageUpdates } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { CommunityMessageLikeStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export function useCommunityMessageLike(messageId: string) {
  const storageKey = SECURE_STORAGE_KEYS.COMMUNITY_MESSAGE_LIKES + messageId;
  const { data, loading } =
    useListenToSecureStorageUpdates<CommunityMessageLikeStorage>(storageKey);

  return {
    likeData: data,
    isLiked: data?.liked ?? false,
    loading,
  };
}
